angular.module('unergie.main')
.directive('salesTunnelGrd', ($uibModal, $filter, MetaWatcher, ReferencesService, AuthService, ApiUser, DataAccess, DataAccessSearch, ErrorCatcher, PrmUtilsService) =>
    ({
        restrict: 'E',
        scope: {
            draft: '=',
            prm: '=',
            landscape: '=',
            initialReadings: '=',
            validated: '=',
            disableContractEdition: '=',
        },
        templateUrl: '/states/salesTunnelV2/component/salesTunnelGrd.html',
        link($scope) {
            const INPUT_DATE_FORMAT = 'YYYY-MM-DD'

            $scope.saveDraft = MetaWatcher.notif.bind(null, 'SALES_TUNNEL.SAVE_DRAFT')
            $scope.saveReadings = MetaWatcher.notif.bind(null, 'SALES_TUNNEL.SAVE_READINGS')
            $scope.retractEndDate = moment().add(14, 'days').format(INPUT_DATE_FORMAT)
            $scope.minDesiredMesDate = null
            $scope.maxDesiredMesDate = null
            $scope.computing = false
            $scope.tariff = {}
            $scope.calendarIds = []
            $scope.powers = []
            $scope.readings = {
                base: undefined,
                hp: undefined,
                hc: undefined,
            }

            $scope.isAdmin = () => AuthService.userHasGroup(['data-admin', 'data-reader'])

            // VALIDATORS
            const initComponentValidator = () => {
                MetaWatcher.notif('SALES_TUNNEL.SET_VALIDATORS', {
                    isInterventionTypeValid(store) {
                        const isInterventionRequired = store.draft.force_intervention || (store.draft.is_a_move && (store.draft.subscription_type !== 'MES'))
                        return isInterventionRequired ? !_.isNil(store.draft.choosen_mes_type) : true
                    },
                    isBypassRetractationDefined(store) {
                        return _.isBoolean(store.draft.bypass_retractation)
                    },
                    isSelfReportValid(store) {
                        const notIntervention = !['FIRST_MES', 'MES_INTER', 'CDF_INTER'].includes(store.draft.subscription_type)
                        const communicating = _.get(store.prm, 'prmResult.metter.communicating', false)
                        const mustSelfReport = notIntervention && !communicating

                        if (store.draft.ignore_switch) {
                            return true
                        }
                        if (mustSelfReport && (store.prm.plan_id === 10) && _.isEmpty(store.readings.base)) {
                            return false
                        }
                        if (mustSelfReport && (store.prm.plan_id === 20) && (_.isEmpty(store.readings.hp) || _.isEmpty(store.readings.hc))) {
                            return false
                        }
                        return true
                    },
                    isConsuelValid(store) {
                        return store.draft.subscription_type === 'FIRST_MES' ? store.draft.consuel === true : true
                    },
                })
            }

            $scope.useEstimatedInTwoDays = () => $scope.draft.subscription_type === 'CDF' && $scope.draft.provider_offer !== 'OFFRE_ETE_2018'

            // REFS
            let availablePowers

            $scope.updateMesTariff = function () {
                const isMaxPowerDefined = ($scope.draft.choosen_max_power || $scope.draft.max_power)
                const isIdPCalendarDefined = ($scope.draft.choosen_id_p_calendar || $scope.draft.id_p_calendar)
                $scope.tariff = undefined
                $scope.draft.total = 0
                if ($scope.prm.eligible && isMaxPowerDefined && isIdPCalendarDefined && $scope.draft.subscription_type) {
                    $scope.computing = true
                    const payload = {
                        id_contract: $scope.draft.id,
                        prestationType: $scope.draft.subscription_type,
                        choosen_mes_type: $scope.draft.choosen_mes_type || 'NORMAL',
                        choosen_max_power: $scope.draft.choosen_max_power || $scope.draft.max_power,
                        choosen_id_p_calendar: $scope.draft.choosen_id_p_calendar || $scope.draft.id_p_calendar,
                        specialReport: $scope.draft.force_intervention,
                    }
                    ApiUser.computeTariff({ draft: true }, payload).$promise.then((tariffResult) => {
                        $scope.tariff = tariffResult.toJSON()
                        $scope.draft.modification = $scope.tariff.option && $scope.tariff.option.price
                        const interByOption = $scope.tariff.option && $scope.tariff.option.remote === false
                        let force_intervention = $scope.draft.force_intervention
                        if (interByOption && force_intervention) {
                            force_intervention = false
                        }
                        const st = $scope.prm.prmResult.subscriptionType
                        const subscription_type = ((interByOption || $scope.draft.force_intervention) && ['CDF', 'MES'].includes(st)) ? `${st}_INTER` : st
                        // save only if modified
                        if ($scope.draft.force_intervention !== force_intervention ||
                            $scope.draft.subscription_type !== subscription_type) {
                            $scope.saveDraft({
                                force_intervention: $scope.draft.force_intervention,
                                subscription_type,
                            })
                        }
                    }).catch(ErrorCatcher)
                    .finally(() => {
                        $scope.computing = false
                    })
                }
            }

            $scope.updateAvailablePower = () => {
                ReferencesService.getRef('ot-ps').then((mapping) => {
                    availablePowers = mapping.toJSON()
                    $scope.calendarIds = [{ id: null, label: '-- Choisissez --' }].concat(_.map(availablePowers, (v, k) => ({ id: k, label: v.label })))
                })
            }

            function updateMinDesiredMesDate(bypassRetractation) {
                $scope.minDesiredMesDate = bypassRetractation ? moment().add(1, 'day').format(INPUT_DATE_FORMAT) : $scope.retractEndDate
            }

            function updateMaxDesiredMesDate(prm) {
                if (prm) {
                    $scope.maxDesiredMesDate = moment().add(PrmUtilsService.getMaxDaysForPRMIntervention(prm), 'days').format(INPUT_DATE_FORMAT)
                }
            }

            // INTER
            $scope.forceInter = function () {
                if ($scope.draft.force_intervention && (['CDF', 'MES'].indexOf($scope.prm.prmResult.subscriptionType) > -1)) {
                    $scope.saveDraft({
                        force_intervention: $scope.draft.force_intervention,
                        subscription_type: $scope.prm.prmResult.subscriptionType === 'MES' ? 'MES_INTER' : 'CDF_INTER',
                        choosen_mes_type: _.get($scope.draft, 'choosen_mes_type', 'NORMAL'),
                        desired_mes_date: null,
                    })
                } else if (!$scope.draft.force_intervention) {
                    $scope.saveDraft({
                        force_intervention: $scope.draft.force_intervention,
                        subscription_type: $scope.prm.prmResult.subscriptionType,
                        choosen_mes_type: _.get($scope.draft, 'choosen_mes_type', 'NORMAL'),
                    })
                }
            }

            // REPORT
            $scope.mustSelfReport = () =>
                !(['FIRST_MES', 'MES_INTER'].indexOf($scope.draft.subscription_type) > -1) && !_.get($scope.prm, 'prmResult.metter.communicating', false) &&
                ($scope.tariff && $scope.tariff.remote)

            $scope.initReadings = () => {
                // Hack to init reading on user draft
                $scope.readings = _.assign({}, {
                    base: undefined,
                    hp: undefined,
                    hc: undefined,
                }, $scope.initialReadings)
            }

            $scope.saveIgnoreSwitch = (ignoreSwitch) => {
                if (ignoreSwitch) {
                    $scope.readings = {
                        base: undefined,
                        hp: undefined,
                        hc: undefined,
                    }
                    $uibModal.open({
                        animation: true,
                        size: 'lg',
                        controller: 'bypassReadingsWarningModalCtrl',
                        templateUrl: '/states/salesTunnelV2/modal/bypassReadingsWarningModal.html',
                        backdrop: 'static',
                        resolve: {
                            bulk_purchase() {
                                return $scope.draft.bulk_purchase
                            },
                        },
                    })
                }
                $scope.saveDraft({ ignore_switch: ignoreSwitch })
                $scope.saveReadings($scope.readings)
            }

            // LAST READINGS
            $scope.updateLastReadings = (prm, oldPrm) => {
                // Update last readings
                const isPrmDefined = _.isString(_.get(prm, 'id_prm'))
                const isPrmResultDefined = _.isObject(_.get(prm, 'prmResult'))
                const isDifferentPrm = _.get(prm, 'prmResult') !== _.get(oldPrm, 'prmResult')
                if (isPrmDefined && isPrmResultDefined && isDifferentPrm && prm.prmResult.plan) {
                    DataAccessSearch({ limit: prm.prmResult.plan.id_p_calendar === 'HPHC' ? 2 : 1, orderBy: '-end_date' })
                    .search({ resource: 'readings', id_prm: prm.id_prm }).$promise
                    .then((lastReadingsResult) => {
                        $scope.lastReadings = _.keyBy(lastReadingsResult, 'temp_class')
                    })
                }
            }

            $scope.isOldLastReadings = (date) => moment().subtract(7, 'months').isAfter(date)

            $scope.roundEstimated = (readings_value) => Math.round((readings_value + 500) / 500) * 500

            // UPDATE
            $scope.updateNbDigitsMask = (prm) => {
                // Update number of digit mask
                $scope.nbDigitsMask = _.has(prm, 'prmResult.metter.faceDigits') ? new Array(prm.prmResult.metter.faceDigits + 1).join('9?') : ''
            }

            $scope.disableGrdEdition = () => $scope.disableContractEdition && (!$scope.draft.ready_to_checkout || $scope.draft.checkout_mail_sent)

            // ACTIVATE
            $scope.$watch('draft', (draft) => {
                $scope.form = {
                    bypass_retractation: draft.bypass_retractation,
                    is_a_move: draft.is_a_move,
                    consuel: draft.consuel,
                    ignore_switch: draft.ignore_switch,
                    desired_mes_date: draft.desired_mes_date && moment(draft.desired_mes_date).startOf('day').toDate(),
                }
                updateMinDesiredMesDate(draft.bypass_retractation)

                $scope.updateMesTariff()
            })

            $scope.$watch('prm', (prm, oldPrm) => {
                $scope.updateNbDigitsMask(prm)
                $scope.updateLastReadings(prm, oldPrm)

                updateMaxDesiredMesDate(prm)
            })

            $scope.updateDesiredMesDate = function (date) {
                if (date) {
                    $scope.saveDraft({ desired_mes_date: moment(date).format(INPUT_DATE_FORMAT) })
                }
            }

            const activate = function () {
                initComponentValidator()
                $scope.initReadings()
                $scope.updateAvailablePower()
            }

            updateMinDesiredMesDate()
            updateMaxDesiredMesDate()
            activate()
        },
    })
)
